import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { Divider, Grid2 } from '@mui/material';
import { v4 as uuidv4 } from 'uuid';
import {Mysection, MydivCOM,MydivRUP,Myrow,cardDownload,sanitizetel,initials,capitalize,openURL,EneaButton,parseToLink } from './Style';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import {Chip, Stack,Box,Tab,Tabs} from '@mui/material';
import { Fragment, useEffect } from 'react';
import { useState,useMemo } from 'react';


const cols=(obj)=>{
    return {
        id:obj.id,
        garaid:obj.gara_id,
        link:obj.link_scheda_gara,
        lottoid:obj.lotto_id,
        oggapp:obj.oggetto_appalto,
        dtinizio:obj.dt_inizio,
        chiusura:obj.dt_fine,

    }
}
const GaraCard = ({handleclose,detail,showesiti,showclose})=>{
    //console.log("gara detail are: "+JSON.stringify(detail));
    
        const [showlotto, setLotto] = useState();
       
        const [showesito, setEsito] = useState();

        useEffect(()=>{
            if(detail.lotti.length>0)
                setLotto(detail.lotti[0].gara_lotto_id);
        },[])
    
        const handleChangeLotto = (event, newValue) => {
            setLotto(newValue);
        };


        const ArrayEsiti = ({obj})=>{
            if(obj.esiti.length>0){
                return(
                <Fragment>
                <Mysection text="esiti"/>
                <Box sx={{ width: '100%' }}>
                    <Tabs
                        onChange={showesiti}
                        value={""}
                        aria-label="raccolta esiti">
                        {detail.esiti.map((o)=>{
                            return (
                                <Tab value={o.id} label={o.oggetto_appalto}/>
                            );
                        })}
                    </Tabs>
                    
                </Box>
            </Fragment>)
            }
            return (<></>);
        }  
        
       

        const cardLotto = useMemo(()=>{
            if(showlotto!==undefined){
                const o = detail.lotti.filter( obj => obj.gara_lotto_id===showlotto).pop();
                return (
                    <Grid2 key={uuidv4()}>
                            <Card>
                                <Chip label={"lotto "+o.gara_lotto_id}/>
                                <Myrow name="id" val={o.id}/>
                                <Myrow name="oggetto" val={o.oggetto_appalto}/>
                                <Myrow name="CIG" val={o.CIG}/>
                                <Stack direction="row" spacing={2} sx={{p:2}} alignItems="center">
                                <p>BDNCP</p><a href={"https://dati.anticorruzione.it/superset/dashboard/dettaglio_cig/?cig="+o.CIG} title="vai alla pagina">
                                    <Typography variant="h5" component="span">
                                    <OpenInNewIcon/>{"https://dati.anticorruzione.it/superset/dashboard/dettaglio_cig/?cig="+o.CIG}
                                        </Typography></a>
                                </Stack>
                                <Divider/>
                                <Myrow name="importo netto" val={new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(o.importo_base)||'-'}/>
                                <Myrow name="scadenza offerta" val={o.scadenza_selezione}/>
                                <Myrow name="seduta pubblica aggiudicazione" val={o.seduta_pubblica_aggiudicazione}/>
                                <Myrow name="luogo seduta aggiudicazione" val={o.luogo_seduta_aggiudicazione}/>
                                <Myrow name="durata contratto" val={o.durata_contratto+" "+o.misura_contratto}/>
                                <Myrow name="note" val={o.note}/>
                                
                            <CardContent>
                            <Grid2 container spacing={4} rowGap={2}>
                            {o.allegati.map(p=>{
                                return (
                                <Grid2>
                                    <Card>
                                        <Typography variant="h6" component="div">
                                                {p.tag}
                                        </Typography>
                                        <CardContent>
                                            {cardDownload(p)}
                                        </CardContent>
                                    </Card>
                                </Grid2>);
                            })}
                            </Grid2>
                            <p></p>
                            {o.esiti.length>0 && (
                            <Fragment>
                                <Divider/>
                                <Myrow name="esiti" val={
                                    <Grid2 container spacing={4} sx={{paddingTop:2}} rowGap={2}>
                                        {o.esiti.map(p=>{
                                            return (
                                            <Grid2>
                                                <Card>
                                                    <CardContent>
                                                        <Button size="large" onClick={()=>showesiti(p.id)}>Visualizza scheda esito</Button>
                                                    </CardContent>
                                                </Card>
                                            </Grid2>);
                                        })}
                                    </Grid2>
                                    }/>
                                </Fragment>
                            )}
                            </CardContent>
                            </Card>
                        </Grid2>
                    );
            }
        },[showlotto,detail])
    
        
       

        return (        
                <Card>
                <CardContent>
                    <Mysection text="sintesi"/>
                    <Grid2 container alignItems='center' spacing={{ xs:0 , md:2}} columns={{xs:4, sm:4, md:8, xl:12}} rowGap={3} >
                    <Grid2 size={4}>
                        <Myrow name="id gara" val={detail.id}/> 
                        <Myrow name="importo netto" val={new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(detail.importo_base_asta)||'-'}/>
                        <Myrow name="criterio di aggiudicazione" val={detail.criterio_nome}/>
                        
                    </Grid2>
                    <Grid2 size={4}>
                        <Myrow name="oggetto appalto" val={detail.oggetto_appalto}/>
                        <Myrow name="note" val={detail.note}/>
                        
                        <Myrow name="pubblicazione (testate e quotidiani)" val={detail.pubblicazione_giornalistica}/>
                    </Grid2>
                    <Grid2 size={4}>
                        <Myrow name="scadenza offerta" val={detail.scadenza_offerta}/>
                        <Myrow name="procedura di scelta contraente" val={detail.procedura_nome}/>
                        <Myrow name="pubblicazione giuridica/economica" val={detail.pubblicazione_giuridica}/>
                
                        
                    </Grid2>
                    <Grid2 size={5}>
                        <Stack direction="row" spacing={5} sx={{p:2}} alignItems="center">
                        <p>Dati Responsabile Procedimento</p>
                            <MydivRUP obj={detail}/>
                        </Stack>
                       
                    </Grid2>
                    <Grid2 size={7}>
                        <Stack direction="row" spacing={5} sx={{p:2}} alignItems="center">
                        <p>Componenti della commissione</p>
                            <MydivCOM obj={detail}/>
                        </Stack>
                        
                    </Grid2>
                    </Grid2>    
                    <Divider/>
                    {detail.allegati.length>0 && (
                    <Fragment>
                        <Mysection text="allegati"/>
                        
                        <Grid2 container spacing={10} rowGap={2}>
                            {detail.allegati.map( o=>{
                                return (
                                <Grid2 key={uuidv4()}>
                                    <Card>
                                        <Typography variant="h6" component="div">
                                            {o.tag}
                                        </Typography>
                                        <CardContent>
                                            {cardDownload(o)}
                                        </CardContent>
                                    </Card>
                                </Grid2>)
                            })}
                        </Grid2>
                    </Fragment>)}
                    <Divider/>
                    {detail.lotti.length>0 && (
                        <Fragment>
                        <Mysection text="lotti"/>
                        <Box sx={{ width: '100%' }}>
                            <Tabs
                                onChange={handleChangeLotto}
                                value={showlotto}
                                aria-label="raccolta lotti">
                                {detail.lotti.map((o)=>{
                                    return (
                                        <Tab value={o.gara_lotto_id} label={o.oggetto_appalto}/>
                                    );
                                })}
                            </Tabs>
                            {cardLotto}
                        </Box>
                        </Fragment>
                                                
                    )}
                    <Divider/>
                    
                    
                    
     
                </CardContent>
                
                {showclose===true && (<CardActions>
                    <Button size="large" onClick={handleclose}>Chiudi</Button>
                </CardActions>)}
                </Card>
            )
        };

export { GaraCard };